// TODO: Try switching to AnimatedSprite from pixi.js
import { PixiComponent } from '@pixi/react';
import * as PIXI from 'pixi.js';
export const InternalAnimatedSprite = PixiComponent('InternalAnimatedSprite', {
    create: ({ loop, textures }) => {
        const animatedSprite = new PIXI.AnimatedSprite(textures);
        animatedSprite.loop = loop;
        return animatedSprite;
    },
    applyProps: (instance, oldProps, newProps) => {
        if (newProps.animationSpeed) {
            instance.animationSpeed = newProps.animationSpeed;
        }
    },
    didMount: (instance) => {
        instance.play();
    },
    willUnmount: () => { }
});
